import axios from 'axios';
import { parseTeamMember } from '../parsers/parseTeamMember';
import { RawTeamMember, TeamMemberDto } from '../model/TeamMember';

export const getTeamMember = async (name: string): Promise<RawTeamMember> => {
  const response = await axios.get(`https://raw.githubusercontent.com/mild-blue/about/master/people/${name}.json`);
  const memberData: TeamMemberDto = response.data;
  return parseTeamMember(memberData);
};
